'use client';

import { useTranslations } from 'next-intl';
import { setContactParameter } from '../Form/utils';

interface ContactInformationProps {
  atHome: boolean;
  phone: string;
  address: string;
  city: string;
  zipcode: string;
  setPhone: (value) => void;
  setCity: (value) => void;
  setAddress: (value) => void;
  setZipcode: (value) => void;
  isClickSubmit?: boolean;
}

export const ContactInformation = ({
  atHome,
  phone,
  address,
  city,
  zipcode,
  setPhone,
  setCity,
  setAddress,
  setZipcode,
  isClickSubmit = false,
}: ContactInformationProps) => {
  const tr = useTranslations();

  const fieldWarning = (value: string) => {
    if (!value && isClickSubmit) {
      return (
        <div data-testid="warning-input" className="mandatory-explain">
          {tr('SELECTION.CONTACT_INFORMATION_MISSING')}
        </div>
      );
    }
  };

  return (
    <>
      {atHome && (
        <div className="address-fields">
          <div className="form-fieldset">
            <label className="vtmn-text-input_label" htmlFor="address">
              {tr('PROFILE.CONTENT.ADDRESS')}
            </label>
            <input
              data-testid="address-input"
              className="vtmn-text-input tc_recruitment_answer_text"
              type="text"
              required
              id="address"
              name="address"
              placeholder={tr('FORM.USER_DATA_ADDRESS')}
              value={address}
              onChange={e =>
                setContactParameter('address', e.target.value, setAddress)}
            />
            {fieldWarning(address)}
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-fieldset">
                <input
                  data-testid="zipcode-input"
                  className="vtmn-text-input tc_recruitment_answer_text"
                  required
                  type="text"
                  id="zipcode"
                  name="zipcode"
                  placeholder={tr('FORM.USER_DATA_ZIPCODE')}
                  autoComplete="postal-code"
                  value={zipcode}
                  onChange={e =>
                    setContactParameter('zipcode', e.target.value, setZipcode)}
                />
                {fieldWarning(zipcode)}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-fieldset">
                <input
                  data-testid="city-input"
                  className="vtmn-text-input tc_recruitment_answer_text"
                  required
                  type="text"
                  id="city"
                  name="city"
                  placeholder={tr('FORM.USER_DATA_CITY')}
                  value={city}
                  onChange={e =>
                    setContactParameter('city', e.target.value, setCity)}
                />
                {fieldWarning(city)}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="form-fieldset">
        <label className="vtmn-text-input_label" htmlFor="phone">
          {tr('PROFILE.CONTENT.PHONE')}
        </label>
        <input
          data-testid="phone-input"
          type="tel"
          className="vtmn-text-input tc_recruitment_answer_text"
          id="phone"
          placeholder="+33(0)"
          name="phone"
          value={phone}
          onChange={e => setContactParameter('phone', e.target.value, setPhone)}
        />
        {fieldWarning(phone)}
      </div>
    </>
  );
};
